var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NoteList',{attrs:{"delete-permission":'delete_receipt',"change-permission":'change_receipt',"object-uuid":_vm.receipt.uuid,"plural-object-name":"receipts","object-name":"receipt"}})}
var staticRenderFns = []

export { render, staticRenderFns }